import { PeriodicalPaymentsApplication } from "@/modules/application/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const PeriodicalPaymentsApplicationPage = ({ isEdit, isCopy }: IOperationPageProps) => (
  <PeriodicalPaymentsApplication isEdit={isEdit} isCopy={isCopy}/>
);
